import * as types from '../actions/types';

const initialState = {
  isError: false,
  matchInfo: {}
};

const matchProfileInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MATCH_PROFILE_INFO_REQUEST:
      return {
        ...state,
        error: null
      };
    case types.MATCH_PROFILE_INFO_SUCCEEDED:
      return {
        ...state,
        matchInfo: action.data,
        error: null
      };
    case types.MATCH_PROFILE_INFO_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };
    case types.HIDE_ERROR:
      return {
        ...state,
        isError: false
      };
    default:
      return state;
  }
};

export default matchProfileInfoReducer;
